import { render, staticRenderFns } from "./MemberNotesComponent.vue?vue&type=template&id=2e3b22c2&scoped=true&"
import script from "./MemberNotesComponent.vue?vue&type=script&lang=js&"
export * from "./MemberNotesComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberNotesComponent.vue?vue&type=style&index=0&id=2e3b22c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b22c2",
  null
  
)

export default component.exports